import { render, staticRenderFns } from "./Toggledark.vue?vue&type=template&id=945aaddc&"
import script from "./Toggledark.vue?vue&type=script&lang=js&"
export * from "./Toggledark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports